import { useMutation } from '@apollo/client';
import { EventFormInput } from '__generated__/globalTypes';
import { CreateForm, CreateFormVariables } from 'graphql/mutation/__generated__/CreateForm';
import { DeleteForm, DeleteFormVariables } from 'graphql/mutation/__generated__/DeleteForm';
import { UpdateForm, UpdateFormVariables } from 'graphql/mutation/__generated__/UpdateForm';
import {
    FORM_CREATE_MUTATION,
    FORM_DELETE_MUTATION,
    FORM_UPDATE_MUTATION
} from 'graphql/mutation/guideMutation';
import { EToastType } from 'libs/types/site/IClient';
import { userMessage } from 'libs/utils/logic/ui/uiLogic';

export const useFormMutations = () => {
    const [createMutation] = useMutation<CreateForm, CreateFormVariables>(FORM_CREATE_MUTATION);
    const [updateMutation] = useMutation<UpdateForm, UpdateFormVariables>(FORM_UPDATE_MUTATION);
    const [deleteMutation] = useMutation<DeleteForm, DeleteFormVariables>(FORM_DELETE_MUTATION);

    async function create(title: string) {
        return createMutation({
            variables: {
                title
            },
            onError: () => {
                userMessage(
                    EToastType.ERROR,
                    'Error while saving, please reload the page and try again.'
                );
            }
        });
    }

    async function update(eventFormId: string, form: EventFormInput) {
        return updateMutation({
            variables: {
                eventFormId,
                form
            },
            context: {
                debounceKey: eventFormId
            },
            onError: () => {
                userMessage(
                    EToastType.ERROR,
                    'Error while saving, please reload the page and try again.'
                );
            }
        });
    }

    async function remove(eventFormId: string) {
        return deleteMutation({
            variables: {
                eventFormId
            },
            onError: () => {
                userMessage(
                    EToastType.ERROR,
                    'Error while saving, please reload the page and try again.'
                );
            }
        });
    }

    return {
        create,
        update,
        remove
    };
};
